
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/gallery",
      function () {
        return require("private-next-pages/blog/gallery.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/gallery"])
      });
    }
  